<template>
    <div class="tool">
        <el-tooltip class="item" effect="dark" content="公司列表是否代理记账(静安),否代理记账(奉贤),一键清除业务共享人" placement="top">
            <el-button type="primary" size="mini" @click="heroClearShare">一键清除业务共享人</el-button>
        </el-tooltip>
        <div style="margin-top: 0.2rem;border: 1px dashed darkslateblue;padding: 0.2rem 0.3rem">
            <import tooltip_content="根据公司名称设置所有指定服务人员(重置方式)(默认如果不存在财务登记表,则增加)(一定要先选服务人员)(且展示在财务登记表)" data="\App\Http\Controllers\ToolController::setServicer"
                :extraData="extraData" :show_tooltip="true">
                <template v-slot:name>
                    导入设置服务人员(重置方式)(默认如果不存在财务登记表,则增加)(一定要先选服务人员)(且展示在财务登记表)
                </template>
            </import>
            <servicer @handleChoosed="handleChoosed" />
            <el-form :model="excelForm" ref="excelForm" label-width="135px">
                <el-form-item label="有几行表头?" prop="header">
                    <el-tooltip class="item" effect="dark" content="有几行表头?" placement="top">
                        <el-input type="number" v-model.number="excelForm.header" size="mini"></el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="公司名称在第几列?" prop="company">
                    <el-tooltip class="item" effect="dark" content="公司名称在第几列?" placement="top">
                        <el-input type="number" v-model.number="excelForm.company" size="mini"></el-input>
                    </el-tooltip>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import Import from '../commonReform/Import.vue'
import Servicer from '../AdminComponents/Servicer'
export default {
    name: 'Tool',
    components: { Import, Servicer },
    data() {
        return {
            extraData: '',
            excelForm: {
                header: 1,
                company: 1
            }
            
        }
    },
    methods: {
        heroClearShare() {
            this.$axios.delete('api/api3/hero_delete_share').then(({ data }) => {
                if (data.code === 0) {
                    this.$message.success(data.msg)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        handleChoosed(val) {
            const newObj = Object.assign({},val,this.excelForm)
            this.extraData = JSON.stringify(newObj)
        }
    }
}
</script>

<style scoped>
.tool {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/Tool.vue